/**
 * What: Shopify audience merchant-facing copy.
 * Transport / data-flow: Pure string dictionary segment merged by shopify-component-copy.ts for Shopify UI consumers.
 *
 */
export const shopifyComponentAudienceCopy = {
    audienceStudioAudienceSetEditor: {
        all001: 'All',
        female002: 'Female',
        male003: 'Male',
        checkTheAudience004: 'Check the audience',
        profileTraits007: 'Profile traits',
        whoShouldShoppersRepresent008: 'Who should the simulated shoppers represent?',
        audienceMarket009: 'Audience market',
        audienceMarketHelp020: 'Shopper profiles come from census data so shoppers start from a broad market baseline before any store background is applied.',
        infoSymbol022: 'i',
        minimumAge011: 'Minimum age',
        maximumAge012: 'Maximum age',
        gender013: 'Gender',
        incomeBand018: 'Income band',
        employment019: 'Employment',
        loadingMarkets020: 'Loading markets…',
        noSupportedMarkets021: 'No supported markets',
    },
    /** Text the Worker puts in the audience sections' blocks; the app draws it and owns none of it. */
    audienceSections: {
        chooseMarket: 'Choose a market',
        ageBracket: 'Age Bracket',
        resetFilters: 'Reset audience filters',
        retryCheck: 'Check again',
        marketsUnavailable: "We couldn't load the audience markets. Change any field to check again.",
        incomeEmploymentUnavailable: 'Income and employment options are not available for this market.',
        customerGroupsUnavailable: "We couldn't load your customer groups. Your selection is kept. Change any field to check again.",
        customerGroupsEmpty: 'Customer groups appear here once your store has enough synced customers.',
        customerGroupsLoading: 'Loading your customer groups…',
    },
    audienceStudioAudienceSetStorePatternSummary: {
        noShopifyPurchaseOrProduct001: 'No Shopify purchase or product patterns are available yet.',
        exampleSyntheticShoppers002: 'Example simulated shoppers',
        previewShoppersShowHowThe003: 'Preview shoppers show how the selected base profile and background tags combine before test prompting.',
        syntheticShopper004: 'Simulated shopper',
        measuredAudienceComposition005: 'Measured audience composition',
        eachDotRepresents006: 'Each dot represents one of 100 simulated shoppers. Colors show the supplied customer-group mix; rings show the selected Shopper Background share.',
        compositionAriaLabel007: '100 shopper composition',
        otherStoreGroups008: 'Other store groups',
        unassignedGroup009: 'Unassigned',
    },
    audienceStudioShopperBackgroundTagSelector: {
        noTagSelected001: 'No tag selected',
        noTag002: 'No tag',
        change005: 'Change',
        backgroundTags006: 'Background tags',
        chooseOneTagPerCategory007: 'Choose one tag per category.',
    },
    audienceStudioCustomerGroupPicker: {
        title001: 'Customer background',
        subtitle002: "Built from Shopify's customer groups — the same data behind the customer analytics in your Shopify admin. Counts are real customers as of your last sync. The test simulates shoppers shaped like them, never the customers themselves.",
        wholeStoreMix003: 'Whole store mix',
        wholeStoreMixDetail004: 'All groups, in proportion',
        tooFewCustomers005: 'Too few customers to build from',
        fromYourStoreBadge006: 'From your store',
        simulatedBadge007: 'Simulated',
        frameCaptionStore008: 'Percentages are measured across your whole store.',
        frameCaptionGroup009: 'Percentages are measured within the selected customer group and change when you change group.',
        claimBoundary010: 'These are simulated shoppers, not a survey of your actual customers.',
        incompleteFrameTitle012: 'Indicative audience composition',
        incompleteFrameDescription013: "We couldn't read some customer records, so these proportions may be incomplete.",
        incompleteFrameCaption014: 'Available store data may be incomplete; use this mix as directional context.',
        noLongerAvailable015: 'No longer available',
    },
    // Keys are the merged-group labels from SHOPIFY_RFM_MERGED_GROUPS in @testfeed/shopify-contracts.
    audienceStudioCustomerGroupStories: {
        'Best customers': "Shops like a store's best customer — buys often, recently, and spends the most.",
        'Steady shoppers': 'Shops like a regular who buys now and then.',
        'Drifting away': 'Shops like someone whose buying tailed off after a real run of orders.',
        'Gone quiet': 'Shops like a once-regular whose interest went cold and needs a clear reason to re-engage.',
        'Just arrived': 'Shops like someone who just made a first purchase and is still forming expectations.',
        'Never bought': 'Shops like someone who browses the category but has never bought.',
    },
};
//# sourceMappingURL=audience.js.map